import { Fragment } from 'react';
import { Layouts } from '~/shared';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledContainer, StyledShadow } from './Background.styled';

const Background: React.FC = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.VehicleMoveDay} />
		)}
		<StyledContainer className={`${Layouts.VehicleRegistration}-background`}>
			<StyledShadow />
		</StyledContainer>
	</Fragment>
);

export { Background };
